var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import UserService from '../../api/UserService';
import CommonService from '../../api/CommonService';
var Password = (function (_super) {
    __extends(Password, _super);
    function Password() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isEdit = false;
        _this.formData = {
            account_gender: "1",
            account_nickname: "",
            account_password: "",
            supplier_role_id: "",
            supplier_role_name: "",
            account_email: "",
            organ_id: ''
        };
        _this.organList = [];
        _this.powerAuthList = [];
        return _this;
    }
    Password.prototype.created = function () {
        this.service = UserService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    Password.prototype.mounted = function () {
        if (this.isEdit) {
            this.$refs.form.style.height = '300px';
            this.formData = JSON.parse(JSON.stringify(this.rowData));
            console.info(this.rowData);
            this.formData.account_gender = this.rowData.account_gender.toString();
        }
        ;
        this.getOrganList();
        this.getRoleNameList();
    };
    Password.prototype.getOrganList = function () {
        var _this = this;
        this.commonService.getOrganList().then(function (res) {
            var data = res.data.data;
            _this.organList = data || [];
            if (!_this.isEdit) {
                _this.formData.organ_id = _this.organList.length && _this.organList[0].organ_id;
            }
        });
    };
    Password.prototype.getRoleNameList = function () {
        var _this = this;
        this.service.getRoleNameList().then(function (res) {
            _this.powerAuthList = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    Password.prototype.close = function () {
        var _this = this;
        this.$confirm("您修改的内容尚未保存，确定要放弃这些内容吗?", "提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function (res) {
            if (res) {
                _this.$closeDialog();
            }
        }).catch(function () { });
    };
    Password.prototype.save = function () {
        var _this = this;
        if (!this.formData.supplier_role_id) {
            this.$message.error("请选择岗位！");
            return;
        }
        else {
            this.powerAuthList.forEach(function (item) {
                if (item.supplier_role_id == _this.formData.supplier_role_id) {
                    _this.formData.supplier_role_name = item.supplier_role_name;
                }
            });
        }
        this.$validator.validateScopes().then(function (res) {
            if (res) {
                _this.saveAction();
            }
        });
    };
    Password.prototype.saveAction = function () {
        var _this = this;
        if (this.isEdit) {
            var params = Object.assign(this.formData, {
                account_id: this.rowData.account_id
            });
            this.service.editSave(params).then(function (res) {
                _this.$closeDialog();
                _this.$emit("edit:ok");
                _this.$message.success(res.data.msg || "保存成功");
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
        else {
            this.service.addSave(this.formData).then(function (res) {
                _this.$closeDialog();
                _this.$emit("save:ok");
                _this.$message.success(res.data.msg || "保存成功");
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
    };
    Password = __decorate([
        Component
    ], Password);
    return Password;
}(VueDialog));
export default Password;
